// extracted by mini-css-extract-plugin
export default {"container":"E5dkPfIvXkMX68zfItr5","header":"mZ4dYVFGfTkjihqnCqzB","subtitle":"cKLxwzMdMu4yblvYbU5W"};